const NS = 'SearchResultPage';
const CLS = 'searchResultPage';
const CLS_HIDE = 'd-none';

import * as Api from '../../../../global/js/api';
import { utils } from '../../../../global/js/utils';
import { mediaQuery } from '../../../../global/js/wool/mediaQuery';
import { initPagination } from '../../../../global/js/pagination';
import Handlebars from 'handlebars';
import { ifCond } from '../../../../../handlebarsHelpers';
import { SearchResultItemWidget } from '../../../widgets/searchResultItemWidget/js/searchResultItemWidget';
import { SearchFilterCheckboxWidget } from '../../../widgets/searchFilterCheckboxWidget/js/searchFilterCheckboxWidget';

export class SearchResultPage {
    constructor(element) {
        this.element = element;
        this.$element = $(element);

        this.siteId = this.$element.data('siteId');
        this.pageSize = this.$element.data('pageSize');
        this.getApi = this.$element.data('eventApi');
        this.emptyMessage = this.$element.data('emptyMessage') || 'No results found.';
        this.mediaQuery = mediaQuery;

        this.loadingSpinner = $('.loading-spinner');
        this.$itemsList = this.$element.find(`.tpl-content-list`);
        this.$pagination = this.$element.find(`.tpl-content-pagination`);
        this.$sidebar = $(`.${CLS}-sidebar`);
        this.$searchInp = this.$element.find(`.${CLS}-search-input`);
        this.$searchInpClearBtn = this.$element.find(`.${CLS}-clearBtn`);
        this.$selects = this.$sidebar.find(`.${CLS}-select`);
        this.$resultTxt = this.$element.find(`.${CLS}-resultTxt`);
        this.$fltBtnMb = this.$element.find(`.${CLS}-fltBtnMb`);
        this.$fltBtnCloseMb = this.$sidebar.find(`.${CLS}-fltBtnCloseMb`);
        this.$fltApplyBtnMb = this.$sidebar.find(`.${CLS}-fltApplyBtnMb`);
        this.$fltResetBtnMb = this.$sidebar.find(`.${CLS}-fltResetBtnMb`);

        this.params = {
            siteId: this.siteId,
            pageNumber: 1,
            pageSize: this.pageSize,
            keyword: this.$searchInp.val()
        };

        this.setItemTemplate();
        this.handleSearchInput();
        this.showClearBtn();
        this.initCheckbox();
        this.setCheckboxParam();
        this.handleSelect();
        this.handleFilterBtnMb();

        if(!_.isEmpty(window.location.search)) {
            this.getItems();
        }

        this.$element.on('pagination.trigger', () => {
            this.getItems(true);
        });
    }

    getItems(scrollToTop = false) {
        let url = this.getApi;

        if(!_.isEmpty(this.params)) {
            url += `?${$.param(this.params)}`;
        }

        this.$itemsList.empty();
        this.loadingSpinner.addClass('is-active');
        this.updateUrl();

        Api.getApi(url).then((data) => {
            let items = data.results;

            if(items.length > 0) {
                items.forEach((item) => {
                    let itemMarkup = this.itemTemplate(item);
                    this.$itemsList.append(`${itemMarkup}`);
                    new SearchResultItemWidget(this.$element.find('.searchResultItemWidget').last()[0]);
                });

                this.updateResultText({
                    totalCount: data.totalCount,
                    keyword: this.params.keyword
                });
            }
            else {
                this.updateResultText('');
            }

            if(scrollToTop) {
                this.$element.trigger('pagination.scrollToTop');
            }

            initPagination(this.pageSize, data.totalCount, this.$pagination, this);
            this.loadingSpinner.removeClass('is-active');
        }, () => {
            this.loadingSpinner.removeClass('is-active');
        });
    }

    setItemTemplate() {
        let itemPartial = require('../../../widgets/searchResultItemWidget/tmpl/searchResultItemWidget.hbs');
        Handlebars.registerPartial('searchResultItemWidget', itemPartial);

        let template = `
            {{> searchResultItemWidget
                wg="searchResultItemWidget"
                ns="SearchResultItemWidget"
            }}
        `;
        let precompiled = new Function('return ' + Handlebars.precompile(template))();
        this.itemTemplate = Handlebars.template(precompiled);

        Handlebars.registerHelper('ifCond', ifCond);
    }

    updateResultText(data) {
        this.$resultTxt.removeClass(CLS_HIDE);

        if(data) {
            this.$resultTxt.html(`${data.totalCount} Results ${data.keyword ? `for ${data.keyword}`: ''}`);
        }
        else {
            this.$resultTxt.html(this.emptyMessage);
        }
    }

    handleSearchInput() {
        this.$searchInp.on('keyup', (event) => {
            this.showClearBtn();
            if(event.keyCode === 13) {
                this.params['keyword'] = $(event.currentTarget).val().trim();
                this.params.pageNumber = 1;
                this.getItems(true);
            }
        });

        this.$searchInpClearBtn.on('click', () => {
            this.$searchInp.val('');
            this.$searchInp.focus();
            this.showClearBtn();
        });
    }

    showClearBtn() {
        let searchVal = this.$searchInp.val();
        if(searchVal) {
            this.$searchInpClearBtn.removeClass(CLS_HIDE);
        }
        else {
            this.$searchInpClearBtn.addClass(CLS_HIDE);
        }
    }

    initCheckbox() {
        let $checkboxWg = this.$sidebar.find('.searchFilterCheckboxWidget');

        $checkboxWg.each((i, obj) => {
            new SearchFilterCheckboxWidget(obj, _.debounce((cbVal) => {
                this.params.pageNumber = 1;
                this.setCheckboxParam();

                if(!this.mediaQuery.breakpointMaxWidth(this.mediaQuery.BREAKPOINTS.MD)) {
                    this.getItems();
                }
            }, 500));
        });
    }

    setCheckboxParam() {
        let $checkboxWg = this.$sidebar.find('.searchFilterCheckboxWidget');
        let allCbVal = [];

        $checkboxWg.each((i, obj) => {
            let $el = $(obj);
            let cbVal = [];

            $el.find(`input[type="checkbox"]:checked`).each((i, ckbx) => {
                cbVal.push($(ckbx).val());
            });

            allCbVal.push({
                name: $el.data('filter-key'),
                value: cbVal
            });
        });

        _.each(allCbVal, (obj, i) => {
            if(obj.value.length === 0) {
                delete this.params[obj.name];
            }
            else {
                this.params[obj.name] = obj.value.join(',');
            }
        });
    }

    handleSelect() {
        this.$selects.on('change', (event) => {
            let $element = $(event.currentTarget);
            let filterKey = $element.data('filter-key');
            if(!(_.isNil(this.params[filterKey]) && $element.val() === '')) {
                // Ensure that the filterKey does not match the current select value
                if(this.params[filterKey] !== $element.val()) {
                    if(_.isNil($element.val()) || $element.val() === '') {
                        delete this.params[filterKey];
                    }
                    else {
                        this.params[filterKey] = $element.val();
                    }

                    this.params.pageNumber = 1;

                    if(!this.mediaQuery.breakpointMaxWidth(this.mediaQuery.BREAKPOINTS.MD)) {
                        this.getItems(true);
                    }
				}
            }
        });
    }

    updateUrl() {
        let uri = document.location.pathname;

        Object.keys(this.params).forEach((key, index) => {
            uri = utils.updateUrlParameter(uri, key, this.params[key]);
        });

        // update url without reload
        window.history.pushState('', '', uri);
    }

    handleFilterBtnMb() {
        const CLS_MB_ACTIVE = 'is-mbActive';

        this.$fltBtnMb.on('click', () => {
            this.$sidebar.addClass(CLS_MB_ACTIVE);
        });

        this.$fltBtnCloseMb.on('click', () => {
            this.$sidebar.removeClass(CLS_MB_ACTIVE);
        });

        this.$fltApplyBtnMb.on('click', () => {
            this.$sidebar.removeClass(CLS_MB_ACTIVE);
            this.getItems(true);
        });

        this.$fltResetBtnMb.on('click', () => {
            this.resetCheckbox();
            this.resetDropdown();
        });
    }

    resetCheckbox() {
        let $checkboxWg = this.$sidebar.find('.searchFilterCheckboxWidget');

        _.each($checkboxWg, (obj) => {
            let $obj = $(obj);
            let filterKey = $obj.data('filter-key');

            delete this.params[filterKey];
            $obj.find('input[type="checkbox"]').prop('checked', false);
        });
    }

    resetDropdown() {
        _.each(this.$selects, (obj) => {
            let $obj = $(obj);
            let filterKey = $obj.data('filter-key');

            delete this.params[filterKey];
            $obj.val('').change();
        });
    }
}
